const getSlackUrl = (alias: string) => {
  const url = `https://slack.com/oauth/v2/authorize?scope=channels%3Ahistory%2Cchannels%3Ajoin%2Cchannels%3Amanage%2Cchannels%3Aread%2Cchat%3Awrite%2Cfiles%3Aread%2Cfiles%3Awrite%2Cgroups%3Ahistory%2Cgroups%3Aread%2Cpins%3Aread%2Creactions%3Aread%2Cteam%3Aread%2Cusers.profile%3Aread%2Cusers%3Aread%2Cusers%3Aread.email%2Cgroups%3Awrite%2Capp_mentions%3Aread%2Ccommands&user_scope=channels%3Aread%2Cchannels%3Awrite%2Cemoji%3Aread%2Cgroups%3Awrite%2Creactions%3Aread%2Cteam%3Aread%2Cgroups%3Aread&client_id=${
    import.meta.env.VITE_PUBLIC_SLACK_CLIENT_ID
  }&state=${alias}`;
  return url;
};

const getSlackWebhookUrl = (alias: string) => {
  const url = `https://slack.com/oauth/v2/authorize?redirect_uri=${
    import.meta.env.VITE_PUBLIC_WEBHOOK_URL
  }&scope=incoming-webhook%2Cchannels%3Ajoin%2Cchannels%3Aread%2Cchat%3Awrite%2Cfiles%3Awrite%2Cgroups%3Aread&user_scope=channels%3Aread%2Cchannels%3Awrite%2Cgroups%3Awrite%2Cgroups%3Aread&granular_bot_scope=1&single_channel=0&tracked=1&client_id=${
    import.meta.env.VITE_PUBLIC_SLACK_CLIENT_ID
  }&state=${alias}`;
  return url;
};

const getIntercomUrl = (alias: string) => {
  const url = `https://app.intercom.com/oauth?client_id=${
    import.meta.env.VITE_PUBLIC_INTERCOM_CLIENT_ID
  }&state=${alias}`;
  return url;
};

const getFrontUrl = (alias: string) => {
  const url = `https://app.frontapp.com/oauth/authorize?response_type=code&client_id=${
    import.meta.env.VITE_PUBLIC_FRONT_CLIENT_ID
  }&redirect_uri=${window.location.origin}/front&state=${alias}`;
  return url;
};

const getYotpoUrl = (alias: string) => {
  const url = `https://integrations-center.yotpo.com/app/#/install/applications/${
    import.meta.env.VITE_PUBLIC_YOTPO_CLIENT_ID
  }?state=${alias}`;
  return url;
};

const getDiscordUrl = (state: string) => {
  const url = `https://discord.com/api/oauth2/authorize?client_id=${
    import.meta.env.VITE_PUBLIC_DISCORD_CLIENT_ID
  }&permissions=8&redirect_uri=${
    window.location.origin
  }/discord&response_type=code&scope=identify%20bot&state=${state}`;
  return url;
};

const getZendeskUrl = (subdomain: string, state: string) => {
  const url = `https://${subdomain}.zendesk.com/oauth/authorizations/new?response_type=code&redirect_uri=${
    window.location.origin
  }/zendesk&client_id=${
    import.meta.env.VITE_PUBLIC_ZENDESK_CLIENT_ID
  }&scope=read%20write&state=${state}`;
  return url;
};

const getGorigasUrl = (subdomain: string, state: string) => {
  const scope =
    'openid+email+profile+offline+users:read+customers:read+tickets:read+integrations:read+integrations:write+tags:read+events:read+custom_fields:read';
  const url = `https://${subdomain}.gorgias.com/oauth/authorize?response_type=code&client_id=${
    import.meta.env.VITE_PUBLIC_GORGIAS_CLIENT_ID
  }&scope=${scope}&redirect_uri=${
    window.location.origin
  }/gorgias&state=${state}`;
  return url;
};

const getGongUrl = (state: string) => {
  const scope =
    'api:calls:read:transcript+api:workspaces:read+api:calls:read:extensive+api:calls:read:basic+api:users:read';
  const url = `https://app.gong.io/oauth2/authorize?
client_id=${
    import.meta.env.VITE_PUBLIC_GONG_CLIENT_ID
  }&response_type=code&scope=${scope}&redirect_uri=${
    window.location.origin
  }/gong&state=${state}`;
  return url;
};

const getTypeformUrl = (alias: string) => {
  const scope =
    'offline+accounts:read+forms:read+images:read+responses:read+webhooks:read+webhooks:write+workspaces:read';
  const url = `https://api.typeform.com/oauth/authorize?client_id=${
    import.meta.env.VITE_PUBLIC_TYPEFORM_CLIENT_ID
  }&redirect_uri=${
    window.location.origin
  }/typeform&state=${alias}&scope=${scope}`;
  return url;
};

const getTiktokShopUrl = (isUS: boolean, state: string) => {
  let url: string;
  if (isUS) {
    url = `https://services.tiktokshops.us/open/authorize?service_id=${
      import.meta.env.VITE_PUBLIC_TIKTOK_CLIENT_ID
    }&state=${state}`;
  } else {
    url = `https://services.tiktokshop.com/open/authorize?service_id=${
      import.meta.env.VITE_PUBLIC_TIKTOK_CLIENT_ID
    }&state=${state}`;
  }
  return url;
};

const getHelpScoutUrl = (alias: string) => {
  const url = `https://secure.helpscout.net/authentication/authorizeClientApplication?client_id=${
    import.meta.env.VITE_PUBLIC_HELPSCOUT_CLIENT_ID
  }&state=${alias}`;
  return url;
};

export {
  getDiscordUrl,
  getFrontUrl,
  getGongUrl,
  getGorigasUrl,
  getHelpScoutUrl,
  getIntercomUrl,
  getSlackUrl,
  getSlackWebhookUrl,
  getTiktokShopUrl,
  getTypeformUrl,
  getYotpoUrl,
  getZendeskUrl,
};
